export default "__VITE_PUBLIC_ASSET__07d73bca__"